import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

import HeaderBtns from "../components/DealTracker/HeaderBtns";
import TableActionBtns from "../components/DealTracker/TableActionBtns";
import DemoBtn from "../components/DealTracker/DemoBtn";
import MailNotificationBtn from "../components/DealTracker/MailNotificationBtn";
import SheetsTab from "../components/DealTracker/SheetsTab";

ModuleRegistry.registerModules([AllCommunityModule]);

export default function DealTrackerLayout() {
  return (
    <div className="min-h-screen">
      {/* Top Bar */}
      <HeaderBtns />

      <div className="flex flex-wrap items-center justify-between">
        <div className="flex items-center gap-2">
          <DemoBtn />
          <MailNotificationBtn />
        </div>
        <TableActionBtns />
      </div>

      <SheetsTab />
    </div>
  );
}
